export const UNDERLYING_LIST_TEST_ID = "underlying-list";
export const UNDERLYING_LIST_DESCRIPTION_TEST_ID = "underlying-list-description";
export const UNDERLYING_LIST_HEADING_TEST_ID = "underlying-list-heading";
export const UNDERLYING_LIST_SECTION_DESCRIPTION_TEST_ID = "underlying-list-section-description";
export const UNDERLYING_LIST_SECTION_HEADING_TEST_ID = "underlying-list-section-heading";
export const UNDERLYING_LIST_SWITCH_BUTTON_TEST_ID = "underlying-list-switch-button";
export const UNDERLYING_LIST_PERIOD_FILTER_TEST_ID = "underlying-list-period-filter";
export const UNDERLYING_LIST_FULL_LIST_LINK_TEST_ID = "underlying-list-full-list-link";
export const UNDERLYING_LIST_TREND_WIKIFOLIO_TEST_ID = "underlying-list-trend-wikifolio";
